import React from "react";
import { connect } from "react-redux";
import AddIcon from "../UIComponents/AddIcon";
import Autocomplete from "react-autocomplete";
import { searchCrewMgmt, searchCrewMgmtDidmount } from "../Actions/CrewManagement";
import CrewManagementCard from "./CrewManagementCard";
import { getShipnameList } from "../Actions/HelpersAPI";
import Role from "../helpers/role";

const SearchItem = {
  crewId: "",
  name: "",
  shipName: "",
  fromDate: "",
  toDate: "",
  designation: "",
  shipId: 0,
  clientId: 0,
  PageNumber: 1,
  PageSize: 25,
};
let userRole = localStorage.getItem("UserRoles");

class CrewManagement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchData: {
        crewId: "",
        name: "",
        shipName: "",
        shipId: 0,
        clientId: 0,
        fromDate: "",
        toDate: "",
        designation: "",
        PageNumber: 1,
        PageSize: 25,
      },
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.SearchData = this.SearchData.bind(this);
    this.ClearInput = this.ClearInput.bind(this);
  }

  componentDidMount() {
    const { match, dispatch, ClearSearchvalue } = this.props;
    if (ClearSearchvalue) {
      this.ClearInput();
    }
    dispatch({ type: "SubBannerTitle", data: "Crew Management" });
    dispatch(searchCrewMgmtDidmount(this.state.searchData, 1));
  }

  /*   componentDidUpdate() {
      const { dispatch, match, ClearSearchvalue } = this.props;
       if (ClearSearchvalue ) {
          this.ClearInput();
          }
      
    } */


  renderShipNameTitle(state, val) {
    return (state?.shipName || "").toLowerCase().indexOf((val || "").toLowerCase()) !== -1;
  }

  handleAnnualSearchChange = (e) => {
    const { dispatch } = this.props;
    this.state.searchData.shipName = e.target.value;
    this.setState({});
  };

  handleAnnualSelectChange = (value, field, id, fieldId) => {
    const { dispatch } = this.props;
    this.state.searchData[field] = value;
    this.state.searchData[fieldId] = id;
    this.setState({});
  };

  handleInputChange(e) {
    let nodeName = e.target.name;
    this.state.searchData[nodeName] = e.target.value;
    this.setState({});
  }

  SearchData(Pgno) {
    this.state.searchData.PageNumber = Pgno;
    this.props.dispatch(searchCrewMgmt(this.state.searchData, Pgno));
  }

  ClearInput() {
    let param = { ...SearchItem };
    this.setState(
      {
        searchData: param,
      },
      () => {
        this.props.dispatch(searchCrewMgmt(this.state.searchData, 1));
      }
    );
  }
  BacktoPrevious() {
    this.props.history.goBack();
  }
  render() {
    const { showSidePane, SearchCrew, ShipNameList, Loading, showShipName } =
      this.props;

    return (
      <div className="full-height">
        <div className="pt-3">
          <div className="row px-3 pb-3">
            <button
              className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
              onClick={() => this.BacktoPrevious()}
            >
              <div style={{ position: 'relative' }}>
                <span className="backarr">&larr;</span> <span style={{ marginLeft: "18px" }}>Back</span>
              </div>
            </button>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="panel-box">
                <div
                  className=" card MM-card-header mb-0"
                  style={{ backgroundColor: "white" }}
                >
                  <div
                    className="card-body flex"
                    style={{
                      padding: "0rem",
                      backgroundColor: "#1a3464",
                      color: "white",
                    }}
                  >
                    <h5
                      className="card-title ml-2 mt-2"
                      style={{ color: "092a51" }}
                    >
                      Crew Management
                    </h5>
                    {userRole == Role.mmpl ? (<></>) :
                      userRole == Role.staff ? (<>
                        <div
                          className="m-1 flex"
                          onClick={() => this.AddStaffCrew()}>
                          <span className="card-title m-auto">Add Crew</span>
                          <AddIcon />
                        </div></>) :
                        (<>
                          <div
                            className="m-1 flex"
                            onClick={() => this.AddKeyword()}>
                            <span className="card-title m-auto">Add Crew</span>
                            <AddIcon />
                          </div>
                        </>)}
                  </div>
                </div>
                <div className="search-filter-box">
                  <div className="row pb-3">
                    <div
                      className={showSidePane ? "col-lg-6 " : "col-lg-4 "}
                    >
                      <label className="form-label">Crew Id</label>
                      <br></br>
                      <input
                        className="form-control"
                        type="text"
                        name="crewId"
                        placeholder="Crew Id"
                        value={this.state.searchData.crewId}
                        onChange={(e) => this.handleInputChange(e)}
                      ></input>
                    </div>
                    <div
                      className={showSidePane ? "col-lg-6 " : "col-lg-4 "}
                    >
                      <label className="form-label">Name</label>
                      <br></br>
                      <input
                        className="form-control"
                        type="text"
                        name="name"
                        placeholder="Name"
                        value={this.state.searchData.name}
                        onChange={(e) => this.handleInputChange(e)}
                      ></input>
                    </div>
                    <div
                      className={showSidePane ? "col-lg-6 " : "col-lg-4 "}
                    >
                      <div
                        className="autocomplete-wrappers"
                        style={{
                          zIndex: showShipName ? 0 : null,
                        }}
                      >
                        <label className="form-label">Ship Name</label>
                        <br></br>
                        {userRole == Role.staff ?
                          <Autocomplete
                            contentEditable={true}
                            value={ShipNameList[0]?.shipName}
                            inputProps={{
                              placeholder: "Ship Name",
                            }}
                            items={ShipNameList ?? []}
                            getItemValue={(item) => item.shipName}
                            shouldItemRender={this.renderShipNameTitle.bind(this)}
                            renderMenu={(item) => (<div className="dropdown">{item}</div>)}
                            renderInput={(props) => {
                              return (
                                <input disabled={true}
                                  {...props} />);
                            }}
                            renderItem={(item, isHighlighted) => (
                              <div
                                className={`items ${isHighlighted ? "selected-items" : ""}`}>
                                {item.shipName}
                              </div>
                            )}
                            onChange={(e) => this.handleAnnualSearchChange(e)}
                            onSelect={(value, item) =>
                              this.handleAnnualSelectChange(value, "shipName", item.shipID, "shipId")}
                          /> :
                          <Autocomplete
                            contentEditable={true}
                            value={this.state.searchData.shipName}
                            inputProps={{
                              placeholder: "Ship Name",
                            }}
                            items={ShipNameList ?? []}
                            getItemValue={(item) => item.shipName}
                            shouldItemRender={this.renderShipNameTitle.bind(
                              this
                            )}
                            renderMenu={(item) => (
                              <div className="dropdown">{item}</div>
                            )}
                            renderItem={(item, isHighlighted) => (
                              <div
                                className={`items ${isHighlighted ? "selected-items" : ""
                                  }`}
                              >
                                {item.shipName}
                              </div>
                            )}
                            onChange={(e) => this.handleAnnualSearchChange(e)}
                            onSelect={(value, item) =>
                              this.handleAnnualSelectChange(
                                value,
                                "shipName",
                                item.shipID,
                                "shipId"
                              )
                            }
                          />}
                      </div>
                    </div>

                    <div
                      className={showSidePane ? "col-lg-12" : "col-lg-12"}
                    >
                      <label className="mt-4"></label>
                      <br></br>
                      <div
                        className="search-btn-col"
                        style={{ textAlign: "end" }}
                      >
                        <button
                          className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                          type="submit"
                          onClick={() => this.SearchData(1)}
                        >
                          {" "}
                          Search{" "}
                        </button>

                        <button
                          className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                          type="button"
                          onClick={() => this.ClearInput()}
                        >
                          {" "}
                          Clear{" "}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {SearchCrew ? (
            <CrewManagementCard
              arraylist={SearchCrew.data}
              pageSize={SearchCrew.pagination.pageSize}
              currentPage={SearchCrew.pagination.currentPage}
              totalRecords={
                SearchCrew.pagination.totalcount
                  ? SearchCrew.pagination.totalcount
                  : 0
              }
              setUpdatedState={(value) => this.SearchData(value)}
            />
          ) : null}
        </div>
      </div>

    );
  }

  AddKeyword = () => {
    this.props.history.push(`/Home/Management/AddCrewMember`);
  };
  AddStaffCrew = () => {
    this.props.history.push(`/Home/AddCrewMember`);
  };
}

function mapStateToProps(state) {
  return {
    ShipNameList: state.UserManageReducer.ShipNameList || [],
    showSidePane: state.SidePanReducer.sidePan || false,
    SearchCrew: state.CrewManagementReducer.SearchCrew,
    Loading: state.PageLoaderReducer.loading,
    showShipName: state.SidePanReducer.shipName || false,
    ClearSearchvalue: state.SidePanReducer.ClearSearchvalue || false,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(CrewManagement);
